export enum UserPermissionsForGroupsEnum {
    groupsManagement = 'groups_management',
    usersManagement = 'users_management',
    groupStats = 'group_stats',
    usersStats = 'users_stats',
    waitlisted = 'waitlisted',
}
